import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';
import seenIcon from './assets/Seen.svg';
import alertIcon from './assets/Alert.svg';

const StyledMessageContainer = styled(FlexContainer)`
  width: 100%;
  height: auto;
  min-height: 40px;
  border-radius: 4px;
  background-color: ${({ error }) => (error ? '#ffcbde' : '#c5fff1')};
  justify-content: flex-start;
  align-items: center;
  padding: 8px;

  p {
    color: ${({ error }) => (error ? '#d10a52' : '#066f55')};
  }

  img {
    width: 20px;
    margin-right: 8px;
  }
`;

const Notify = ({ error, message }) => (
  <StyledMessageContainer error={error}>
    {error ? <img src={alertIcon} alt="icon" /> : <img src={seenIcon} alt="icon" />}
    <p className="small">{message}</p>
  </StyledMessageContainer>
);

Notify.propTypes = {
  error: PropTypes.bool,
  message: PropTypes.string.isRequired,
};

Notify.defaultProps = {
  error: false,
};

export default Notify;
